export default __webpack_public_path__ + "static/media/image-58.3080a47f.png";